import { createContext } from "react";

export default createContext({
  socket: {},
  setSocket: () => null,
});
